import { Box, Button, Card, CardActions, CardContent, CardHeader, TextField, Tooltip } from "@mui/material";
import debounce from "lodash.debounce";
import { useMemo } from "react";
import Ratings from "../Ratings";
import { useAddReviewState } from "./State/AddReviewState";
import { AppFeatureLookup, defaultUnauthorizedMessage } from "../../../../../App/Constants/AbacConstants";
import { useFeaturePermission } from "../../../../../App/State/Hooks/abacHooks";

export function AddReview() {
  const {
    getters: { rating, review, isReviewValid, saveReviewLoading },
    setters: { setRating },
    handlers: { handleReviewChange, handleSaveReview },
  } = useAddReviewState();

  const debouncedSaveReviewHandler = useMemo(() => debounce(handleSaveReview, 300), [handleSaveReview]);
  const addReviewAccess = useFeaturePermission(AppFeatureLookup.ProfileAddCandidateReviews);
  return (
    <Card
      sx={{
        width: 1,
        mt: 3,
        boxShadow: "none",
        background: "transparent",
        p: 0,
      }}
      raised={false}
    >
      <CardHeader title="Add a review" sx={{ px: 0 }} />
      <CardContent sx={{ p: 0 }}>
        <Box sx={{ width: 1 }}>
          <Box sx={{ marginBottom: 2 }} data-test={"addreview-rate-candidate"}>
            <Ratings stars={rating} setStars={setRating} readOnly={false} />
          </Box>
          <Box>
            <TextField
              id="addreview-textarea"
              label="Add Review"
              multiline
              rows={5}
              aria-label="addreview-textarea"
              data-test="addreview-textarea"
              value={review}
              error={!isReviewValid}
              helperText={`${review.length}/1500`}
              sx={{
                width: 1,
                px: 0,
                ".MuiOutlinedInput-root": { background: "white" },
              }}
              onChange={addReviewAccess ? handleReviewChange : undefined}
              disabled={!addReviewAccess}
            />
          </Box>
        </Box>
      </CardContent>
      <CardActions sx={{ p: 0, justifyContent: "flex-end" }}>
        <Tooltip title={addReviewAccess ? "Save Candidate Review" : defaultUnauthorizedMessage}>
          <Box>
            <Button
              aria-label="Save Candidate Review"
              type="submit"
              variant="contained"
              color="primary"
              onClick={addReviewAccess ? debouncedSaveReviewHandler : undefined}
              data-test="addreview-save-button"
              disabled={!addReviewAccess || !isReviewValid || saveReviewLoading}
            >
              Save
            </Button>
          </Box>
        </Tooltip>
      </CardActions>
    </Card>
  );
}
